import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { Subscription } from '@melio/subscriptions-api';
import { useContext } from 'react';

import { SubscriptionContext } from './context/SubscriptionContext';
import { SubscriptionContextType } from './context/types';

type UseSubscriptionType = () => { subscription: Subscription };

export const useSubscription: UseSubscriptionType = () => {
  const [isPlatformSubscriptionsEnabled] = useFeature(FeatureFlags.PlatformSubscriptions, false);
  const {
    subscription,
    onboarding: { hasNoSubscription },
  } = useContext<SubscriptionContextType>(SubscriptionContext);

  if (!isPlatformSubscriptionsEnabled || hasNoSubscription) {
    // cast to ensure return type is a defined Subscription (just to keep typescript happy if FF off)
    return { subscription: {} as Subscription };
  }

  if (!subscription) {
    throw new Error('No subscription found. useSubscription must be used within a SubscriptionProvider');
  }
  return { subscription };
};
